var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "logo" }, [
      _vm._v("\n  Track a "),
      _c("br"),
      _vm._v(" "),
      _c("span", [_vm._v("Healthier Life")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }